import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.seller}sellers/vatRate/${COMMON_QUERY_PARAMS.SELLER_ID}`;

interface GetServiceBusConfigurationArgs {
  ownerId: string;
  sellerId: string;
}

export const getVatRateBySellerIdQuery = async (
  payload: GetServiceBusConfigurationArgs,
): Promise<BackResponse<number> | BackResponseFailure> => {
  try {
    const { sellerId, ownerId } = payload;
    const url = buildUrl(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
      {
        ownerId,
      },
    );

    return await apiCall<BackResponse<number>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
